export default "__VITE_ASSET__VzJbqoBD__"